export default function removeAccents(str: string) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function removeAccentsAndLowerCase(str: string) {
    return removeAccents(str).toLowerCase();
}

export function removeAccentsLowerCaseUnderscoreNonAlphanumberic(str: string) {
    return removeAccents(str).replace(/[^a-zA-Z0-9]/g, '_').toLowerCase();
}

export function searchMatch(keyword: string, word: string) {
    return removeAccentsAndLowerCase(word).includes(removeAccentsAndLowerCase(keyword));
}

export function isValidEmail(email: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function isValidUrl(url: string) {
    return /^(ftp|http|https):\/\/[^ "]+$/.test(url);
}

export function normalizeSearchTerm(term: string) {
    return term.trim().replace(/\s+/g, ' ');
}
